/* @flow */

import React from 'react'
import { differenceInCalendarDays, parseISO } from 'date-fns'

import NoEarlierAppointments from 'tve/components/no_earlier_appointments'
import WrongTimeWrongPlace from 'tve/components/wrong_time_wrong_place'

const AppointmentGridHeader = ({ data, currentDate, advisor, branch }) => {
  const startDate = data && data.dateRange && parseISO(data.dateRange.end)
  const days = differenceInCalendarDays(startDate, currentDate)
  return (
    <>
      {days > 14 ? <NoEarlierAppointments advisor={advisor} branch={branch} /> : null}
      {advisor && data && data.branches.length > 1 ? <WrongTimeWrongPlace advisor={advisor} /> : null}
    </>
  )
}

export default AppointmentGridHeader
